<div
  class="ive-panel"
  role="alert"
  aria-live="polite"
  *ngIf="groups.length">
  <p class="ive-summary" *ngIf="summary">{{ summary }}</p>
  <p class="ive-dup" *ngIf="duplicateNote">{{ duplicateNote }}</p>
  <ul class="ive-list">
    <li *ngFor="let group of groups; trackBy: trackByTestCaseId">
      <span class="ive-id">{{ group.testCaseId }}</span>
      <span class="ive-chips">
        <span class="ive-chip ive-chip--dup" *ngIf="group.isDuplicate">Duplicated test case</span>
        <span
          class="ive-chip"
          *ngFor="let label of group.fieldLabels; trackBy: trackByLabel">{{ label }}</span>
      </span>
    </li>
  </ul>
</div>
